import React from 'react';
import { useTranslation } from 'react-i18next';
import { SelectField, MultiSelectField } from '../';

interface LangFieldProps {
    name: string;
    multiple?: boolean;
    placeholder?: string;
    className?: string;
};

const LangField = (props: LangFieldProps) => {
    const { name, multiple, placeholder, className } = props;

    const { t } = useTranslation();

    const options = ['fr', 'en', 'de'].map(lang => ({
        value: lang,
        label: t(`common.languages.${lang}`)
    }));

    if (multiple)
        return (
            <MultiSelectField
                name={name}
                options={options}
                placeholder={placeholder}
                className={className}
            />
        );

    return (
        <SelectField
            name={name}
            options={options}
            placeholder={placeholder}
            className={className}
        />
    );
};

export default LangField;
